// Campagnes d'acquisition qui adaptent les textes du parcours d'inscription
// (page signup puis onboarding). Une campagne se reconnaît à ses UTM, sans
// paramètre dédié : le lien envoyé reste un lien UTM standard, et la variante
// suit l'utilisateur jusqu'à l'onboarding par le même chemin que l'attribution
// (cookie `mx_attrib`, puis `users.utm_*` après création du compte).
//
// `utmContentIncludes` restreint la variante à une partie des liens d'une même
// campagne : les autres liens (hors emailing) restent attribués à la campagne
// mais gardent les textes standard.
//
// Ajouter une campagne : une entrée ici, puis ses textes sous
// `campaigns.<id>` dans `messages/{fr,en}.json` (signup, étape sources,
// écran de bienvenue).
export const SIGNUP_CAMPAIGNS = [
  // Congrès A3P 2026 (industrie pharmaceutique), liens de l'emailing
  // seulement : invitation à tester Mindexia sur ses documents avant de passer
  // sur le stand.
  {
    id: 'a3pCongress',
    utmSource: 'a3p',
    utmCampaign: 'congres_2026',
    utmContentIncludes: 'email',
    partnerLogo: { src: '/partners/a3p.png', alt: 'A3P', width: 480, height: 338 },
  },
] as const;

export type SignupCampaign = (typeof SIGNUP_CAMPAIGNS)[number]['id'];

export type SignupCampaignPartnerLogo = (typeof SIGNUP_CAMPAIGNS)[number]['partnerLogo'];

type CampaignUtm = {
  utm_source?: string | null;
  utm_campaign?: string | null;
  utm_content?: string | null;
};

const norm = (v: string | null | undefined) => v?.trim().toLowerCase() || null;

export function resolveSignupCampaign(utm: CampaignUtm | null | undefined): SignupCampaign | null {
  const source = norm(utm?.utm_source);
  const campaign = norm(utm?.utm_campaign);
  const content = norm(utm?.utm_content) ?? '';
  if (!source || !campaign) return null;
  const match = SIGNUP_CAMPAIGNS.find(
    (c) =>
      c.utmSource === source &&
      c.utmCampaign === campaign &&
      content.includes(c.utmContentIncludes),
  );
  return match?.id ?? null;
}

export function signupCampaignPartnerLogo(
  campaign: SignupCampaign | null | undefined,
): SignupCampaignPartnerLogo | null {
  return SIGNUP_CAMPAIGNS.find((c) => c.id === campaign)?.partnerLogo ?? null;
}
